import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import { clearAdsPlan, getAdsPlan, removeAdsPlan, setAdsPlan } from 'redux/modules/adsPlan';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import { hexToRGB } from '../../helpers/util';
import { Spinner } from 'components';
import * as styles from './AdPlanPicker.scss';
var AdPlanPicker = (_dec = connect(function (state, ownProps) {
  return {
    adsPlan: state.adsPlan.adsPlan,
    gettingAdsPlan: state.adsPlan.gettingAdsPlan,
    settingAdsPlan: state.adsPlan.settingAdsPlan,
    removingAdsPlan: state.adsPlan.removingAdsPlan,
    theme: state.theme
  };
}, {
  clearAdsPlan: clearAdsPlan,
  getAdsPlan: getAdsPlan,
  removeAdsPlan: removeAdsPlan,
  setAdsPlan: setAdsPlan
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(AdPlanPicker, _Component);

  var _super = _createSuper(AdPlanPicker);

  function AdPlanPicker(props) {
    var _this;

    _classCallCheck(this, AdPlanPicker);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleAddPlan", function () {
      _this.props.setAdsPlan(_this.props.orgId, {
        amount: _this.state.selectedPlan.price * 100
      }).then(function (plan) {
        _this.setState({
          showPlanConfirmDialog: false
        });

        _this.setBoxState(plan);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleAddCustomPlan", function () {
      _this.props.setAdsPlan(_this.props.orgId, {
        amount: parseInt(_this.state.customPlanAmount) * 100
      }).then(function () {
        return _this.setState({
          showPlanConfirmDialog: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setBoxState", function (plan) {
      if (plan) {
        var highlightedBox;

        var selectedPlan = _this.props.boxes.find(function (b, index) {
          if (b.price === plan.data.active.amount / 100) {
            highlightedBox = index;
            return b;
          }
        });

        if (selectedPlan) {
          _this.setState({
            selectedPlan: selectedPlan,
            highlightedBox: highlightedBox,
            planIndex: highlightedBox
          });
        } else {
          _this.setState({
            customPlan: true,
            customPlanAmount: plan.data.active.amount / 100,
            planIndex: 1
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderBoxes", function (boxes) {
      var colors = _this.props.theme.colors;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: styles.boxWrap
      }, boxes.map(function (box, index) {
        return /*#__PURE__*/React.createElement("div", {
          className: styles.box,
          onMouseEnter: function onMouseEnter() {
            return _this.setState({
              highlightedBox: index
            });
          },
          onMouseLeave: function onMouseLeave() {
            var highlighted = _this.props.adsPlan ? _this.state.planIndex : 1;

            _this.setState({
              highlightedBox: highlighted
            });
          },
          onClick: function onClick() {
            return _this.setState({
              showChangePlanDialog: false,
              showPlanConfirmDialog: true,
              selectedPlan: _this.props.boxes[index]
            });
          },
          style: index === _this.state.highlightedBox ? {
            borderColor: colors.secondaryColor,
            backgroundColor: hexToRGB(colors.secondaryColor, 0.1)
          } : {
            borderColor: colors.secondaryColor
          },
          key: index
        }, /*#__PURE__*/React.createElement("h4", {
          className: styles.price,
          style: index === _this.state.highlightedBox ? {
            color: colors.secondaryColor
          } : {}
        }, "$", box.price, /*#__PURE__*/React.createElement("span", {
          className: styles.monthSubText,
          style: index === _this.state.highlightedBox ? {
            color: colors.secondaryColor
          } : {}
        }, "/mo")));
      })), /*#__PURE__*/React.createElement(RaisedButton, {
        label: "Create Custom Plan",
        onClick: function onClick() {
          return _this.setState({
            showChangePlanDialog: false,
            showCustomPlanDialog: true,
            customPlan: true
          });
        }
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderConfirmText", function () {
      return _this.state.customPlan ? /*#__PURE__*/React.createElement("p", {
        style: {
          color: _this.props.theme.colors.gray1
        }
      }, "You have created a custom plan of $", _this.state.customPlanAmount, "/mo. The credit card on file for", ' ', _this.props.clientName, " will be billed monthly.") : /*#__PURE__*/React.createElement("p", {
        style: {
          color: _this.props.theme.colors.gray1
        }
      }, "You have selected the $", _this.state.selectedPlan.price, "/mo plan. The credit card on file for", ' ', _this.props.clientName, " will be billed monthly.");
    });

    _defineProperty(_assertThisInitialized(_this), "renderCustomPlanArea", function () {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.customPlanWrap
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RaisedButton, {
        label: "Show Standard Plans",
        onClick: function onClick() {
          return _this.setState({
            showCustomPlanDialog: false,
            showChangePlanDialog: true,
            customPlan: false
          });
        }
      })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "$"), /*#__PURE__*/React.createElement(TextField, {
        hintText: "300",
        value: _this.state.customPlanAmount,
        onChange: function onChange(event) {
          return _this.setState({
            customPlanAmount: event.target.value
          });
        }
      }), /*#__PURE__*/React.createElement("span", null, "/mo")));
    });

    _this.state = {
      selectedPlan: {
        price: 100
      },
      showPlanConfirmDialog: false,
      showChangePlanDialog: false,
      showCustomPlanDialog: false,
      showRemovePlanDialog: false,
      highlightedBox: null,
      planIndex: 1,
      customPlan: false,
      customPlanAmount: 0
    };
    return _this;
  }

  _createClass(AdPlanPicker, [{
    key: "componentDidMount",
    value:
    /** *********************************************************************************************
     LIFECYCLE METHODS
    ************************************************************************************************/
    function componentDidMount() {
      var _this2 = this;

      if (this.props.orgId) {
        this.props.getAdsPlan(this.props.orgId).then(function (plan) {
          if (plan.data.active) {
            _this2.setBoxState(plan);
          }
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.clearAdsPlan();
    }
    /** *********************************************************************************************
     EVENT HANDLER METHODS
    ************************************************************************************************/

  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var planConfirmActions = [/*#__PURE__*/React.createElement(RaisedButton, {
        label: "Cancel",
        onClick: function onClick() {
          return _this3.setState({
            showPlanConfirmDialog: false
          });
        },
        style: {
          marginRight: 24
        }
      }), /*#__PURE__*/React.createElement(RaisedButton, {
        disabled: this.props.settingAdsPlan,
        label: "Confirm",
        secondary: true,
        onClick: this.state.customPlan ? this.handleAddCustomPlan : this.handleAddPlan
      })];
      var changePlanActions = [/*#__PURE__*/React.createElement(RaisedButton, {
        label: "Cancel",
        onClick: function onClick() {
          return _this3.setState({
            showChangePlanDialog: false
          });
        },
        style: {
          marginRight: 24
        }
      })];
      var customPlanActions = [/*#__PURE__*/React.createElement(RaisedButton, {
        label: "Cancel",
        onClick: function onClick() {
          return _this3.setState({
            showCustomPlanDialog: false
          });
        },
        style: {
          marginRight: 24
        }
      }), /*#__PURE__*/React.createElement(RaisedButton, {
        disabled: this.props.settingAdsPlan,
        label: "Create Custom Plan",
        secondary: true,
        onClick: function onClick() {
          return _this3.setState({
            showCustomPlanDialog: false,
            showPlanConfirmDialog: true,
            customPlan: true
          });
        }
      })];
      var removePlanActions = [/*#__PURE__*/React.createElement(RaisedButton, {
        label: "Cancel",
        onClick: function onClick() {
          return _this3.setState({
            showRemovePlanDialog: false
          });
        },
        style: {
          marginRight: 24
        }
      }), /*#__PURE__*/React.createElement(RaisedButton, {
        disabled: this.props.removingAdsPlan,
        label: "Remove Ads Plan",
        secondary: true,
        onClick: function onClick() {
          return _this3.props.removeAdsPlan(_this3.props.orgId).then(function () {
            _this3.setState({
              showRemovePlanDialog: false,
              customPlan: false,
              customPlanAmount: 0,
              planIndex: 1
            });
          });
        }
      })];
      var activeAdsPlan = false;

      if (this.props.adsPlan) {
        if (this.props.adsPlan.active) {
          activeAdsPlan = true;
        }
      }

      return /*#__PURE__*/React.createElement("div", null, this.props.gettingAdsPlan ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : /*#__PURE__*/React.createElement("div", {
        className: styles.wrap
      }, !activeAdsPlan ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
        className: styles.header
      }, "Choose a plan"), this.renderBoxes(this.props.boxes)) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, this.props.clientName, " is currently on a $", this.props.adsPlan.active.amount / 100, "/mo ads plan."), /*#__PURE__*/React.createElement(RaisedButton, {
        disabled: this.props.settingAdsPlan,
        label: "Change Ads Plan",
        secondary: true,
        style: {
          marginRight: 40,
          marginTop: 8
        },
        onClick: function onClick() {
          return _this3.state.customPlan ? _this3.setState({
            showCustomPlanDialog: true
          }) : _this3.setState({
            showChangePlanDialog: true
          });
        }
      }), /*#__PURE__*/React.createElement(RaisedButton, {
        label: "Remove Ads Plan",
        style: {
          marginTop: 8
        },
        onClick: function onClick() {
          return _this3.setState({
            showRemovePlanDialog: true
          });
        }
      }))), /*#__PURE__*/React.createElement(Dialog, {
        title: "Confirm your ads plan choice",
        open: this.state.showPlanConfirmDialog,
        onRequestClose: function onRequestClose() {
          return _this3.setState({
            showPlanConfirmDialog: false
          });
        },
        actions: planConfirmActions,
        modal: true
      }, this.renderConfirmText()), /*#__PURE__*/React.createElement(Dialog, {
        title: "Change ads plan",
        open: this.state.showChangePlanDialog,
        onRequestClose: function onRequestClose() {
          return _this3.setState({
            showChangePlanDialog: false
          });
        },
        actions: changePlanActions
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
        style: {
          color: this.props.theme.colors.gray1
        }
      }, "Click a plan below to select that ads plan."), this.renderBoxes(this.props.boxes))), /*#__PURE__*/React.createElement(Dialog, {
        title: "Create custom ads plan",
        open: this.state.showCustomPlanDialog,
        onRequestClose: function onRequestClose() {
          return _this3.setState({
            showCustomPlanDialog: false
          });
        },
        actions: customPlanActions
      }, this.renderCustomPlanArea()), /*#__PURE__*/React.createElement(Dialog, {
        title: "Are you sure?",
        open: this.state.showRemovePlanDialog,
        onRequestClose: function onRequestClose() {
          return _this3.setState({
            showRemovePlanDialog: false
          });
        },
        actions: removePlanActions
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          color: this.props.theme.colors.gray1
        }
      }, "This will remove the monthly ads plan from ", this.props.clientName, ".")));
    }
  }]);

  return AdPlanPicker;
}(Component), _defineProperty(_class2, "defaultProps", {
  boxes: [{
    price: 50
  }, {
    price: 100
  }, {
    price: 200
  }],
  orgId: '',
  clientName: ''
}), _temp)) || _class);
export default AdPlanPicker;